import React, { useState } from "react";
import AppLayout from "../layout";
import { Button, Form, Input, Result } from "antd";
import { PhoneOutlined, MailOutlined } from "@ant-design/icons";
import emailjs from "@emailjs/browser";
import { BrowserView, MobileOnlyView } from "react-device-detect";
import { ContactMobile } from "./mobile";

const { TextArea } = Input;

const Contact = () => {
  return (
    <AppLayout>
      <BrowserView>
        <ContactForm />
      </BrowserView>
      <MobileOnlyView>
        <ContactMobile />
      </MobileOnlyView>
    </AppLayout>
  );
};

const ContactForm = () => {
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(false);

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const sendEmail = (values) => {
    setSending(true);
    emailjs
      .send("service_sk5xfye", "template_gk7zcar", values, "cW0kTgMmXhntnO3fh")
      .then(
        function (response) {
          setSuccess(true);
          setSending(false);

          console.log("SUCCESS!", response.status, response.text);
        },
        function (error) {
          console.log("FAILED...", error);
          setSending(false);
        }
      );
  };

  return (
    <div className="por_contact">
      <div className="image_contact"></div>

      <div className="contact_form">
        {!success ? (
          <>
            <h1>CONTACTEZ-MOI</h1>
            <p>
              Merci de l'intérêt que vous portez a mon profile. Veuillez
              utiliser ce formulaire pour nous contacter. Réponse rapide assurée
              !
            </p>
            <div className="list-icon-text">
              <div style={{ marginRight: 20 }}>
                <PhoneOutlined />
                <span>| +221 78 139 22 17</span>
              </div>
              <div>
                <MailOutlined />
                <span className="mail">| dialllohali2017@gmail.com</span>
              </div>
            </div>

            <Form
              name="basic"
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
              initialValues={{
                remember: true,
              }}
              onFinish={sendEmail}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              disabled={sending}
            >
              <Form.Item
                name="firstName"
                rules={[
                  {
                    required: true,
                    message: "SVP Donnez votre Prenom",
                  },
                ]}
              >
                <Input placeholder="Prenom" />
              </Form.Item>

              <Form.Item
                name="email"
                rules={[
                  {
                    required: true,
                    message: "SVP Donnez votre E-mail",
                    type: "email",
                  },
                ]}
              >
                <Input placeholder="E-mail" />
              </Form.Item>

              <Form.Item name="phone">
                <Input placeholder="Telephone" />
              </Form.Item>

              <Form.Item
                name="message"
                rules={[
                  {
                    required: true,
                    message: "SVP Entrez votre message",
                  },
                ]}
              >
                <TextArea rows={4} placeholder="Redigez votre message" />
              </Form.Item>

              <Button
                type="primary"
                className="btn-submit"
                htmlType="submit"
                loading={sending}
              >
                Envoyer
              </Button>
            </Form>
          </>
        ) : (
          <Result
            status="success"
            title="Message envoyé avec succès !"
            extra={[
              <Button
                type="primary"
                onClick={() => {
                  setSuccess(false);
                }}
              >
                RETOUR
              </Button>,
            ]}
          />
        )}
      </div>
    </div>
  );
};

export default Contact;
